
<script lang="ts">
	import { Router, Route } from "svelte-navigator";
	import RouteGuard from "./components/RouteGuard.svelte";
	import { ROL_SUPERADMIN } from "./evironment";
	import FormsForm from "./Pages/formsForm.svelte";
	import FormsList from "./Pages/formsList.svelte";
	import Historic from "./Pages/Historic.svelte";
	import Index from "./Pages/index.svelte";
	import Login from "./Pages/login.svelte";
	import UsersList from "./Pages/usersList.svelte";
	import ViewAnswers from "./Pages/ViewAnswers.svelte";

</script>

<Router primary={false}>

	<Route path="/login">
		<Login />
	</Route>

	<Route path="/">
		<RouteGuard>
			<Index />
		</RouteGuard>
	</Route>
	<Route path="formularios">
		<RouteGuard>
			<FormsList />
		</RouteGuard>
	</Route>
	<Route path="historial">
		<RouteGuard>
			<Historic />
		</RouteGuard>
	</Route>
	<Route path="respuestas/:instanceId" let:params>
		<RouteGuard>
			<ViewAnswers instanceId={params.instanceId} />
		</RouteGuard>
	</Route>
	<Route path="formulario/:id" let:params>
		<RouteGuard>
			<FormsForm formId={params.id} />
		</RouteGuard>
	</Route>
	<Route path="/usuarios">
		<RouteGuard>
			<UsersList />     
		</RouteGuard>
	</Route>
	<Route path="/settings">
		<RouteGuard allowRoles={[ROL_SUPERADMIN]}>
			Ajustes
		</RouteGuard>
	</Route>
	<Route path="*">
		NotFound 
	</Route>
</Router>

